const iosStoreUrl = (countryCode: string) => {
  return 'https://apps.apple.com/app/abnk-mobile-finance/id6738076252'
};

export default iosStoreUrl;
